exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-core-video-player-layers{z-index:11;position:absolute;left:0;bottom:0;width:100%;height:100%}", ""]);

// exports
